import { isDataRange } from './type-guards.js';
import type { XYChartThresholdDatapoint } from '../../types/xy-chart.js';

/**
 * Retrieves either the 'yMin' or 'yMax' value from `data` based on `type`,
 * defaulting to `data.y` if the specific key is missing or 0 in case
 * of no `data.y`.
 *
 * @param data - Object containing potential 'yMin', 'yMax', or 'y' properties.
 * @param type - Specifies whether to retrieve 'min' (yMin) or 'max' (yMax).
 * @returns The 'yMin', 'yMax', or 'y' value from the data object.
 */
export const getYValue = (
  data: XYChartThresholdDatapoint,
  type: 'min' | 'max',
) => {
  const key = type === 'min' ? 'yMin' : 'yMax';
  if (isDataRange(data)) {
    return data[key];
  }

  return data.y;
};
